import request from "./request";

// 注册
export function register(data){
    return request({
      url: 'admin/Login/register',
      method: 'post',
      data:data
    })
}

// 登录
export function captchaLogin(data){
  return request({
    url: 'admin/Login/captchaLogin',
    method: 'post',
    data:data
  })
}

// 发送验证码
export function sendVerificationCode(data){
  return request({
    url: 'common/Sms/sendVerificationCode',
    method: 'post',
    data:data
  })
}

// 管理员信息
export function getManagerDetail(token){
  return request({
    url: 'admin/Manager/getManagerDetail',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取每日一词列表
export function getDailyWordList(data,token){
  return request({
    url: 'admin/DailyWord/getDailyWordList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取每日一词详情
export function getDailyWordDetail(data,token){
  return request({
    url: 'admin/DailyWord/getDailyWordDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 添加/编辑每日一词
export function saveDailyWord(data,token){
  return request({
    url: 'admin/DailyWord/saveDailyWord',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除每日一词
export function delDailyWord(data,token){
  return request({
    url: 'admin/DailyWord/delDailyWord',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改每日一词发布状态
export function updateDailyWordStatus(data,token){
  return request({
    url: 'admin/DailyWord/updateDailyWordStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 导入每日一词
export function importDailyWord(data,token){
  return request({
    url: 'admin/DailyWord/importDailyWord',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取演讲稿类型列表
export function getSpeechTypeList(data,token){
  return request({
    url: 'admin/Speech/getSpeechTypeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取演讲稿类型详情
export function getSpeechTypeDetail(data,token){
  return request({
    url: 'admin/Speech/getSpeechTypeDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑演讲稿类型
export function saveSpeechType(data,token){
  return request({
    url: 'admin/Speech/saveSpeechType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除演讲稿类型
export function delSpeechType(data,token){
  return request({
    url: 'admin/Speech/delSpeechType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改演讲稿类型发布状态
export function updateSpeechTypeStatus(data,token){
  return request({
    url: 'admin/Speech/updateSpeechTypeStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取可使用演讲类型列表
export function getSpeechTypeUseList(token){
  return request({
    url: 'admin/Speech/getSpeechTypeUseList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑演讲
export function saveSpeech(data,token){
  return request({
    url: 'admin/Speech/saveSpeech',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取演讲列表
export function getSpeechList(data,token){
  return request({
    url: 'admin/Speech/getSpeechList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑演讲说明、ai点评
export function saveSpeechDetail(data,token){
  return request({
    url: 'admin/Speech/saveSpeechDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑单人练习、对话练习
export function saveSpeechSub(data,token){
  return request({
    url: 'admin/Speech/saveSpeechSub',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑导入演讲稿
export function saveSpeechText(data,token){
  return request({
    url: 'admin/Speech/saveSpeechText',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改演讲发布状态
export function updateSpeechStatus(data,token){
  return request({
    url: 'admin/Speech/updateSpeechStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取演讲详情
export function getSpeechDetail(data,token){
  return request({
    url: 'admin/Speech/getSpeechDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取七牛云获取上传token
export function getUploadToken(token){
  return request({
    url: 'common/Upload/getUploadToken',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取Vip列表
export function getVipList(data,token){
  return request({
    url: 'admin/Vip/getVipList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取Vip详情
export function getVipDetail(data,token){
  return request({
    url: 'admin/Vip/getVipDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑Vip
export function saveVip(data,token){
  return request({
    url: 'admin/Vip/saveVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取苹果会员列表
export function getVipIphoneList(token){
  return request({
    url: 'admin/Vip/getVipIphoneList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 删除Vip
export function delVip(data,token){
  return request({
    url: 'admin/Vip/delVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改Vip发布状态
export function updateVipStatus(data,token){
  return request({
    url: 'admin/Vip/updateVipStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取数字人列表
export function getDigitalHumanList(data,token){
  return request({
    url: 'admin/DigitalHuman/getDigitalHumanList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑数字人
export function saveDigitalHuman(data,token){
  return request({
    url: 'admin/DigitalHuman/saveDigitalHuman',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取数字人详情
export function getDigitalHumanDetail(data,token){
  return request({
    url: 'admin/DigitalHuman/getDigitalHumanDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改数字人发布状态
export function updateDigitalHumanStatus(data,token){
  return request({
    url: 'admin/DigitalHuman/updateDigitalHumanStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取数字人用户列表
export function getDigitalHumanUserList(token){
  return request({
    url: 'admin/DigitalHuman/getDigitalHumanUserList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取练习类型列表
export function getPracticeTypeList(data,token){
  return request({
    url: 'admin/Practice/getPracticeTypeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取练习类型详情
export function getPracticeTypeDetail(data,token){
  return request({
    url: 'admin/Practice/getPracticeTypeDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除练习类型
export function delPracticeType(data,token){
  return request({
    url: 'admin/Practice/delPracticeType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改练习发布状态
export function updatePracticeTypeStatus(data,token){
  return request({
    url: 'admin/Practice/updatePracticeTypeStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取可使用练习类型列表
export function getPracticeTypeUseList(token){
  return request({
    url: 'admin/Practice/getPracticeTypeUseList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑练习类型
export function savePracticeType(data,token){
  return request({
    url: 'admin/Practice/savePracticeType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取练习列表
export function getPracticeList(data,token){
  return request({
    url: 'admin/Practice/getPracticeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑练习
export function savePractice(data,token){
  return request({
    url: 'admin/Practice/savePractice',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取练习详情
export function getPracticeDetail(data,token){
  return request({
    url: 'admin/Practice/getPracticeDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改练习发布状态
export function updatePracticeStatus(data,token){
  return request({
    url: 'admin/Practice/updatePracticeStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑练习关卡
export function savePracticeLevel(data,token){
  return request({
    url: 'admin/Practice/savePracticeLevel',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑练习关卡及题目
export function savePracticeLevelTopic(data,token){
  return request({
    url: 'admin/Practice/savePracticeLevelTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取意见反馈列表
export function getFeedbackList(data,token){
  return request({
    url: 'admin/Feedback/getFeedbackList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取用户列表
export function getUserList(data,token){
  return request({
    url: 'admin/User/getUserList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 导出用户
export function exportUser(token){
  return request({
    url: 'admin/User/exportUser',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取订单列表
export function getOrderList(data,token){
  return request({
    url: 'admin/User/getOrderList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取加量包列表
export function getPkgList(data,token){
  return request({
    url: 'admin/Vip/getPkgList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑加量包
export function savePkg(data,token){
  return request({
    url: 'admin/Vip/savePkg',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取加量包详情
export function getPkgDetail(data,token){
  return request({
    url: 'admin/Vip/getPkgDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除加量包
export function delPkg(data,token){
  return request({
    url: 'admin/Vip/delPkg',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改加量包发布状态
export function updatePkgStatus(data,token){
  return request({
    url: 'admin/Vip/updatePkgStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 词库列表
export function getLexiconList(data,token){
  return request({
    url: 'admin/ClockIn/getLexiconList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑词库
export function saveLexicon(data,token){
  return request({
    url: 'admin/ClockIn/saveLexicon',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取词库详情
export function getLexiconDetail(data,token){
  return request({
    url: 'admin/ClockIn/getLexiconDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除词库
export function delLexicon(data,token){
  return request({
    url: 'admin/ClockIn/delLexicon',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取打卡列表
export function getClockInList(data,token){
  return request({
    url: 'admin/ClockIn/getClockInList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 打卡详情
export function getClockInDetail(data,token){
  return request({
    url: 'admin/ClockIn/getClockInDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 打卡审核
export function clockInVerify(data,token){
  return request({
    url: 'admin/ClockIn/clockInVerify',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加打卡ai评语提示词
export function addClockInAiCueWord(data,token){
  return request({
    url: 'admin/ClockIn/addClockInAiCueWord',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取提现列表
export function getTransferList(data,token){
  return request({
    url: 'admin/Transfer/getTransferList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 驳回
export function Reject(data,token){
  return request({
    url: 'admin/Transfer/Reject',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 再次提现
export function Withdrawal(data,token){
  return request({
    url: 'admin/Transfer/Withdrawal',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取核销码列表
export function getVerifyCodeList(data,token){
  return request({
    url: 'admin/Verify/getVerifyCodeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加核销码
export function addVerifyCode(data,token){
  return request({
    url: 'admin/Verify/addVerifyCode',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 兑换码
export function giveVip(data,token){
  return request({
    url: 'api/Index/giveVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 前台登录
export function NewcaptchaLogin(data,token){
  return request({
    url: 'api/Login/captchaLogin',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 前台获取头马vip信息
export function getToastmastersVip(data,token){
  return request({
    url: 'api/User/getToastmastersVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 前台获取头马vip信息
export function addOrder(data,token){
  return request({
    url: 'api/Order/addOrder',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 前台查询订单状态
export function getOrderStatus(data,token){
  return request({
    url: 'api/Order/getOrderStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取评估演讲列表
export function getEvaluateList(data,token){
  return request({
    url: 'admin/Evaluate/getEvaluateList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取评估演讲详情
export function getEvaluateDetail(data,token){
  return request({
    url: 'admin/Evaluate/getEvaluateDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑评估演讲
export function saveEvaluate(data,token){
  return request({
    url: 'admin/Evaluate/saveEvaluate',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改评估演讲状态
export function updateEvaluateStatus(data,token){
  return request({
    url: 'admin/Evaluate/updateEvaluateStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除评估演讲
export function delEvaluate(data,token){
  return request({
    url: 'admin/Evaluate/delEvaluate',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取徽章列表
export function getBadgeList(data,token){
  return request({
    url: 'admin/Badge/getBadgeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取徽章详情
export function getBadgeDetail(data,token){
  return request({
    url: 'admin/Badge/getBadgeDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除徽章
export function delBadge(data,token){
  return request({
    url: 'admin/Badge/delBadge',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑徽章
export function saveBadge(data,token){
  return request({
    url: 'admin/Badge/saveBadge',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取等级列表
export function getPointsList(data,token){
  return request({
    url: 'admin/Badge/getPointsList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取等级详情
export function getPointsDetail(data,token){
  return request({
    url: 'admin/Badge/getPointsDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑等级
export function savePoints(data,token){
  return request({
    url: 'admin/Badge/savePoints',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除等级
export function delPoints(data,token){
  return request({
    url: 'admin/Badge/delPoints',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑固定词库
export function saveFixedLexicon(data,token){
  return request({
    url: 'admin/ClockIn/saveFixedLexicon',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取固定词库详情
export function getFixedLexiconDetail(token){
  return request({
    url: 'admin/ClockIn/getFixedLexiconDetail',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取ai提示词列表
export function getAiPromptList(data,token){
  return request({
    url: 'admin/AiPrompt/getAiPromptList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取ai提示词详情
export function getAiPromptDetail(data,token){
  return request({
    url: 'admin/AiPrompt/getAiPromptDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑ai提示词
export function saveAiPrompt(data,token){
  return request({
    url: 'admin/AiPrompt/saveAiPrompt',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除ai提示词
export function delAiPrompt(data,token){
  return request({
    url: 'admin/AiPrompt/delAiPrompt',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取课程详情
export function getCourseDetail(data,token){
  return request({
    url: 'admin/Course/getCourseDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑课程
export function saveCourse(data,token){
  return request({
    url: 'admin/Course/saveCourse',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除课程
export function delCourse(data,token){
  return request({
    url: 'admin/Course/delCourse',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改课程状态
export function updateCourseStatus(data,token){
  return request({
    url: 'admin/Course/updateCourseStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取课程列表
export function getCourseList(data,token){
  return request({
    url: 'admin/Course/getCourseList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取官网公告列表
export function getNoticeList(data,token){
  return request({
    url: 'admin/Notice/getNoticeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取官网公告详情
export function getNoticeDetail(data,token){
  return request({
    url: 'admin/Notice/getNoticeDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑官网公告
export function saveNotice(data,token){
  return request({
    url: 'admin/Notice/saveNotice',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改官网公告状态
export function updateNoticeStatus(data,token){
  return request({
    url: 'admin/Notice/updateNoticeStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 富文本图片上传
export function uploadFile(formData, url = 'https://up-as0.qiniup.com') {
  return request({
    url: url,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: progressEvent => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      console.log(`上传进度：${percentCompleted}%`);
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/api.js